<template>
  <div class="full-width">
    <v-card>
      <v-card-title v-if="event.eventDocuments.length > 0">Documents:</v-card-title>
      <v-card-title v-if="event.eventDocuments.length === 0">The event has no documents</v-card-title>
      <v-card-actions>
        <v-row>
          <v-spacer></v-spacer>
          <div
            class="button"
            v-for="doc in event.eventDocuments"
            v-bind:key="doc.documentId"
          >
            <v-btn
              outlined
              @click="openDocument(doc.documentId)"
              ><v-icon left>mdi-open-in-new</v-icon
              >{{ doc.title }}</v-btn
            >
          </div>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import EventsService from '../services/api/EventsService'
import store from '@/store/index.js'

export default {
  name: 'event-documents',
  props: ['event'],

  data: () => ({}),

  created() {
    this.getDocuments(this.event.eventId)
  },
  methods: {
    getDocuments(eventId) {
      store.commit('isLoading')

      EventsService.getEventDocuments(eventId)
        .then(documents => {
          this.event.eventDocuments = documents
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    },
    openDocument(id) {
      const url = '/document/' + id
      window.open(url)
    }
  }
}
</script>
<style lang="scss" scoped>
.button {
  padding: 5px;
}
.full-width {
  width: 100%;
}

</style>
